module.exports = __webpack_public_path__ + "static/urbisAvatar-79793545874da2478677ec2ff15535b5.svg";